/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowtexttitledate4Inputs */

const en_aiflowtexttitledate4 = /** @type {(inputs: Aiflowtexttitledate4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, title and date`)
};

const de_aiflowtexttitledate4 = /** @type {(inputs: Aiflowtexttitledate4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, Titel und Datum`)
};

/**
* | output |
* | --- |
* | "Yes, title and date" |
*
* @param {Aiflowtexttitledate4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowtexttitledate4 = /** @type {((inputs?: Aiflowtexttitledate4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowtexttitledate4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowtexttitledate4(inputs)
	return de_aiflowtexttitledate4(inputs)
});
export { aiflowtexttitledate4 as "aiFlowTextTitleDate" }